module.exports = __webpack_public_path__ + "img/44.2117240c.png";